import { useMutation } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { getSessionNode } from '@/shared/bridge';

/**
 * 로그아웃 mutation — 순수 BE 호출만 담당.
 *
 * side effect (auth store clear, queryClient.clear, LOGIN navigate) 는 caller 책임.
 * best-effort 정책상 BE 성공/실패 무관 caller 가 즉시 정리한다(응답 대기 안 함). 실패는 무시.
 *
 * `accessToken` 을 변수로 받는다 — caller 가 로컬 세션을 즉시 비운 뒤 발사해도 요청이 유효 토큰을
 * 유지하도록 mutate 호출 시점의 스냅샷을 넘긴다(mutationFn 은 async 라 실행 시 store 는 이미 빈 상태).
 */
export function useLogoutMutation() {
  const api = useApiAppLegacy();

  return useMutation({
    mutationFn: (accessToken: string) =>
      api.auth.logout({ session: getSessionNode() }, accessToken),
    retry: false,
  });
}
